import { gql, useSubscription } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { userProfileAttributes } from '../pages/users/constants';
import { authStateChangedAction } from '../redux-store/auth-store';

const myProfileUpdatesForAdminSubscription = gql`
subscription MyProfileUpdatesForAdmin {
  myProfileUpdatesForAdmin {
    crud
    id
    new ${userProfileAttributes}
  }
}`;

function useProfileUpdates() {
  const dispatch = useDispatch();
  const result = useSubscription(myProfileUpdatesForAdminSubscription, {
    fetchPolicy: 'network-only',
    onSubscriptionData: ({ client, subscriptionData: resp }) => {
      const update = resp.data?.myProfileUpdatesForAdmin;
      try {
        if (update) {
          switch (update.crud) {
            case 'update':
              dispatch(authStateChangedAction(update.new));
              break;
            default:
              break;
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
  });
  return result;
}

export default useProfileUpdates;
